import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

/**
 * Transfers event ownership to a new host
 */
export async function transferEventOwnership(eventVaultId?: number, email?: string) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `transferEventOwnership`.")
  if (!email)
    throw new Error("Missing Email: Unable to call `transferEventOwnership`.")

  const endpoint = `api/user/${eventVaultId}/transfer-ownership`

  const response = await axios.post(endpoint, { email })

  return response.data?.Message
}

const TRANSFER_EVENT_OWNERSHIP_KEY = "transferEventOwnership"

export function useTransferEventOwnership(eventVaultId?: number) {
  return useMutation({
    mutationKey: [TRANSFER_EVENT_OWNERSHIP_KEY],
    mutationFn: (email?: string) => transferEventOwnership(eventVaultId, email),
  })
}
